<div class="">
  <div class="wrapper" [ngClass]="{'sidebar-inactive-l':menuInactiveDesktop, 'sidebar-active-m':menuActiveMobile}">

    <div class="topbar clearfix">

      <a id="omega-menu-button" href="#" (click)="toggleMenu($event)">
        <span class="fa {{menuIcon}}" (window:resize)="onResize($event)"></span>
      </a>

      <a id="options-menu-button" href="#" (click)="toggleTopMenu($event)">
        <span class="fa fa-ellipsis-h"></span>
      </a>

      <div id="topbar-icons" class="animated" [ngClass]="{'topbar-icons-visible flipInX':topMenuActive,'flipOutX':topMenuLeaving}">

        <span class="topbar-search" (click)="onSearchClick($event)" style="display: none;">
          <input type="text" placeholder="Search for customer name or loyalty ID..." />
          <span class="topbar-search-icon fa fa-search"></span>
        </span>

        <div class="icon-right">

          <a href="#" id="iconRight" class="topbar-profile" (click)="toggleProfile($event, topbarProfileMenu)">
            <img class="profile" src="assets/layout/images/avatar_1.png" alt="" />
            <span class="topbar-item-text">User</span>
            <span class="topbar-icon fa fa-angle-down"></span>
          </a>

        </div>

      </div>
    </div>

    <div class="sidebar" (click)="onMenuClick($event)">
      <div #scroller data-testid="scroller" class="nano">
        <div class="nano-content sidebar-scroll-content">
    
    
<div class="logo">
  <img class="logo-koncentro" alt=""
       src="assets/layout/images/logo-koncentro.png"
       srcset="assets/layout/images/logo-koncentro@2x.png 2x,
               assets/layout/images/logo-koncentro@3x.png 3x" />
  <div class="version-chip">
    <span class="version-dot"></span>
    <span class="version-text">v{{ appVersion }}</span>
  </div>

<!-- 
       <div class="app-version">
              v{{ appVersion }}
            </div>
    
            <div class="ribbon">
              v{{ appVersion }}
            </div> -->
</div>

          <app-menu *ngIf="ready.menu == true"></app-menu>

        </div>
      </div>
    </div>

    <div class="main">
      <router-outlet></router-outlet>
    </div>

  </div>


  <p-overlayPanel #topbarProfileMenu data-testid="topbarProfileMenu" [styleClass]="'topbar-profile-menu'">
    <img class="profile" src="assets/layout/images/avatar_1.png" alt="" />
    <ul>
      <li id="profile" style="margin-bottom: 10px;"><a style="cursor: pointer" (click)="goToProfile()" ><i class="fa fa-fw fa-sliders"></i><span>{{ 'menu.account' | translate}}</span></a></li>
      <li id="logout" style="margin-bottom: 10px;"><a style="cursor: pointer" (click)="logOut()"><i class="fa fa-fw fa-sign-out"></i><span>{{ 'menu.logout' | translate}}</span></a></li>
      <li id="languages" style="margin-bottom: 10px;"><p-dropdown class="language-menu" [options]="languages" (onChange)="languageChange()" [(ngModel)]="selectedLanguage" [style]="{ width: '100%' }" ></p-dropdown></li>
    </ul>
  </p-overlayPanel>
</div>




// WEBPACK FOOTER //
// ./src/app/views/homepage/homepage.html